import styled from "styled-components";

export const Uploader = styled.label`
  cursor: pointer;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  padding: 5px 25px;
  font-size: 16px;
  background-image: linear-gradient(45deg, #f182e7, #23b8bf, #47c330);
  font-family: sans-serif;
`;

export const Input = styled.input`
  display: none;
`;
